import { c as _c } from "react/compiler-runtime";
import type { ClassValue } from "clsx";
import cn from "@/utils/cn";
export default function Alert(t0) {
  const $ = _c(16);
  let children;
  let className;
  let props;
  let severity;
  if ($[0] !== t0) {
    ({
      severity,
      className,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = severity;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    severity = $[4];
  }
  let severityClassName;
  switch (severity) {
    case "info":
      {
        severityClassName = "bg-blue-500";
      }
  }
  let t1;
  if ($[5] !== className) {
    t1 = cn(className);
    $[5] = className;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== severityClassName) {
    t2 = cn("px-2.5 py-2 rounded", severityClassName);
    $[7] = severityClassName;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== children || $[10] !== t2) {
    t3 = <div className={t2}>{children}</div>;
    $[9] = children;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== props || $[13] !== t1 || $[14] !== t3) {
    t4 = <div className={t1} {...props}>{t3}</div>;
    $[12] = props;
    $[13] = t1;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
}